import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { AuthService } from 'app/auth/auth.service';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { ReportserviceService } from 'app/reports/reportservice.service';
import { ExportService } from 'app/reports/services/export.service';
declare const $: any;
@Component({
  selector: 'app-appointment-summary-doctor-wise-report',
  templateUrl: './appointment-summary-doctor-wise-report.component.html',
  styleUrls: ['./appointment-summary-doctor-wise-report.component.scss']
})
export class AppointmentSummaryDoctorWiseReportComponent implements OnInit {
  isShowDivIf = false;
  public toDaysDate: any;
 
  startdate: any;
  enddate: any;
  comparesionStartDate: any;
  comparesionEndDate: any;
  pageHeading: any;
  isValidDate: any;  
  searchBranchName: number = 0;
  isGraph = false;  
  isgrapandData = false;  
  Bookedtotal: number=0;
  Cancelledtotal: number=0;
  NetBookedtotal: number=0;
  Convertedtotal: number=0;
  Conversiontotal: number=0;
  allBookedtotal: number=0;
  allCancelledtotal: number=0;
  allNetBookedtotal: number=0;
  allConvertedtotal: number=0;
  allConversiontotal: number=0;
   allConversiontotals: number=0;
  AppointmentSummery: any=[];
  Conversiontotals: number=0;

  constructor(public dashboardService: DashboardService, public authService: AuthService, public reportService: ReportserviceService, public datePipe: DatePipe, private exportdata: ExportService) { }

  ngOnInit(): void {  
    this.searchBranchName = 0;
    this.pageHeading = 'Appointment Summary Doctor Wise Report';
    this.toDaysDate = new Date();
    this.toDaysDate = this.datePipe.transform(this.toDaysDate, "yyyy-MM-dd");
    this.comparesionStartDate = this.toDaysDate;
    this.comparesionEndDate = this.toDaysDate;
    this.startdate = this.toDaysDate;
    this.enddate = this.toDaysDate;
    this.getAppointmentSummeryDocterWiseReport(this.authService.Loggeduser.branchid, this.comparesionStartDate, this.comparesionEndDate);
  }

  toggleDisplayDivIf() {
    this.isShowDivIf = !this.isShowDivIf;
  }
  togglegraphIf() {
    this.isGraph = !this.isGraph;
  }
  
  
  getAppointmentSummeryDocterWiseReport(branchid: any, fdate: any, tdate: any) {
    this.AppointmentSummery=[]
    this.allBookedtotal=0;
    this.allCancelledtotal=0;
    this.allNetBookedtotal=0;
    this.allConvertedtotal =0;
    this.allConversiontotal =0;
    this.allConversiontotals =0;
    this.reportService.getAppointmentSummeryDocterWiseReport(branchid, fdate, tdate).subscribe((ex: any) => {
     console.log(ex)
     if(ex.length >0 ){
      if (this.searchBranchName !=0) {
            var x = ex.filter(item => item.fK_ForBranchId == this.searchBranchName);
          } else {
            var x = ex;
          }
          let groupdataa = x.reduce((r, { forBranch }) => {
                if (!r.some(o => o.forBranch == forBranch)) {
                  r.push({ forBranch, branchItem: x.filter(v => v.forBranch == forBranch) });
                }
                return r;
              }, []);
              console.log(groupdataa)
    
              for(var i=0; i< groupdataa.length ;i++){
                this.Bookedtotal=0
                this.Cancelledtotal=0;
                this.NetBookedtotal=0;
                this.Convertedtotal =0;
                this.Conversiontotal =0;
               this.Conversiontotals =0;
               groupdataa[i].branchItem.forEach(xt=>{
                this.Bookedtotal =this.Bookedtotal +  xt.booked;
                this.Cancelledtotal=this.Cancelledtotal + xt.cancelled;
                this.NetBookedtotal=this.NetBookedtotal +  xt.netBooked;
                this.Convertedtotal=this.Convertedtotal + xt.converted;
                this.Conversiontotal=this.Conversiontotal + xt.conversionPercentage;
                this.Conversiontotals=this.Conversiontotal/groupdataa[i].branchItem.length;              
               });
               console.log(groupdataa[i].branchItem.length)
               this.allBookedtotal =this.allBookedtotal +this.Bookedtotal;
               this.allCancelledtotal= this.allCancelledtotal+ this.Cancelledtotal;
               this.allNetBookedtotal=this.allNetBookedtotal +this.NetBookedtotal;
               this.allConvertedtotal=this.allConvertedtotal+ this.Convertedtotal;
               this.allConversiontotal=this.allConversiontotal+ this.Conversiontotals;
               this.allConversiontotals=this.allConversiontotal/groupdataa.length;  
               console.log(groupdataa.length)
                this.AppointmentSummery.push({
                  "branchName":groupdataa[i].forBranch,
                  "branchdata":groupdataa[i].branchItem,
                   "totalBooked": this.Bookedtotal,
                   "totalCancelled":this.Cancelledtotal,
                   "totalNetBooked":this.NetBookedtotal,
                   "totalConverted": this.Convertedtotal,
                   "totalConversion": this.Conversiontotals,                   
                });
        console.log(this.AppointmentSummery)
           
               
              }
             
             }
   

    }, err => {

    })
  }
  onBranchSelected(event: any) {
    this.searchBranchName = event.value;
    this.dateSearch();
  }


  dateSearch() {
    let sdate = this.datePipe.transform(this.comparesionStartDate, "yyyy-MM-dd");
    let edate = this.datePipe.transform(this.comparesionEndDate, "yyyy-MM-dd");
    this.startdate = sdate;
    this.enddate = edate;
    this.isValidDate = this.validateDates(sdate, edate);
    if (this.isValidDate != false) {
      this.getAppointmentSummeryDocterWiseReport(this.authService.Loggeduser.branchid, sdate, edate);
    } else {
      this.dashboardService.openSnackBar("End date should be greater than start date", "OK");
    }
  }
  validateDates(sDate: string, eDate: string) {

    this.isValidDate = true;
    if ((sDate == null || eDate == null)) {
      this.isValidDate = false;
    }

    if ((sDate != null && eDate != null) && (eDate) < (sDate)) {
      this.isValidDate = false;
    }
    return this.isValidDate;
  }

  exportexcel(): void {

     this.exportdata.open_loader_Dialogtwo();
     let element = document.getElementById('content');
     this.exportdata.Newexportxcel(element, this.pageHeading);
   }
 
   printPDF():void{
    this.exportdata.printpDFData();
   }

  public openPDF(): void {
  
    this.exportdata.open_loader_Dialogtwo();
    $("#removeclass").removeClass("grid-scroll");
    let DATA = document.getElementById('content');
    this.exportdata.getexportPDF(DATA, this.pageHeading);
    $("#removeclass").addClass("grid-scroll");

  }
}

